
export const XXL = 2400;
export const XL = 2100;
export const LG = 1900;
export const SLG = 1600;
export const XMD = 1440;
export const MD = 992;
export const SM = 768;
export const XS = 480;
export const XXS = 320;

export const MQ_XXS = `@media (min-width: ${XXS}px)`;
export const MQ_XS = `@media (min-width: ${XS}px)`;
export const MQ_SM = `@media (min-width: ${SM}px)`;
export const MQ_MD = `@media (min-width: ${MD}px)`;
export const MQ_XMD = `@media (min-width: ${XMD}px)`;
export const MQ_SLG = `@media (min-width: ${SLG}px)`;
export const MQ_LG = `@media (min-width: ${LG}px)`;
export const MQ_XL = `@media (min-width: ${XL}px)`;
export const MQ_XXL = `@media (min-width: ${XXL}px)`;

